import type { FormSchema, SectionMeta } from '../types';

// Pulls the section grouping out of a schema so the builder can render and
// re-emit it alongside the flat field list.
const toSectionMetas = (schema: FormSchema | null | undefined): SectionMeta[] =>
  (schema?.['x-ui']?.sections ?? []).map((section) => ({
    key: section.key,
    title: section.title,
    ...(section.sectionId ? { sectionId: section.sectionId } : {})
  }));

export default toSectionMetas;
